// extracted by mini-css-extract-plugin
export default {"file-grid":"style_file-grid__5OR-z"};